import React from "react";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function VideoSkippable({ preview }) {

  //   const handleDownloadPreview = () => {
  //     const previewElement = document.querySelector('.download-preview');
  //     toBlob(previewElement).then(function (blob) {
  //       saveAs(blob, `${preview.name}.png`);
  //     });
  //   };
  return (
    <>

      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />

        <div className="preview-inner">
          <div className="preview-full-image">
            {preview.img_urls && <img src={preview.img_urls} alt="" className="w-full h-full" />}
          </div>
        </div>
      </div>
    </>
  );
}

export default VideoSkippable;
